import React from 'react';
import { makeStyles, Text, Tooltip } from '@knockrentals/knock-shared-web';
import { SERVICE_STATUS_LABEL, SERVICE_STATUS_TOOLTIP } from '../constants';

const useStyles = makeStyles(() => ({
  serviceStatusLabel: {
    color: '#292B3D',
    fontSize: '14px',
    fontFamily: 'Open Sans',
    fontWeight: 600,
    lineHeight: '22px',
  },
}));

export const ServiceStatusLabel = () => {
  const classes = useStyles();
  return (
    <Text className={classes.serviceStatusLabel} variant="subtitle1">
      {SERVICE_STATUS_LABEL}{' '}
      <Tooltip title={SERVICE_STATUS_TOOLTIP}>
        <i className="fa-regular fa-question-circle edit-button-tooltip"></i>
      </Tooltip>
    </Text>
  );
};
